import { motion } from "framer-motion";

const IMAGES = [
  {
    src: "/images/tomahawk.png",
    alt: "Plated tomahawk steak with charred asparagus",
    caption: "Tomahawk, Charred Asparagus",
    wrap: "col-span-12 md:col-span-7",
    aspect: "aspect-[4/3]",
  },
  {
    src: "/images/fish.png",
    alt: "Pan-seared fish with saffron beurre blanc",
    caption: "Sear, Saffron, Fennel",
    wrap: "col-span-12 md:col-span-5 md:mt-24",
    aspect: "aspect-[3/4]",
  },
  {
    src: "/images/dish-steak.jpeg",
    alt: "Sliced filet with béarnaise and haricots verts",
    caption: "Filet, Béarnaise, Haricots Verts",
    wrap: "col-span-12 md:col-span-5",
    aspect: "aspect-[3/4]",
  },
  {
    src: "/images/crudo.png",
    alt: "Delicate crudo with citrus pearls",
    caption: "Crudo, Citrus Pearl",
    wrap: "col-span-12 md:col-span-7 md:mt-24",
    aspect: "aspect-[4/3]",
  },
  {
    src: "/images/dish-tenderloin.jpeg",
    alt: "Beef tenderloin with rösti, mushrooms and jus",
    caption: "Tenderloin, Rösti, Jus",
    wrap: "col-span-12 md:col-span-6",
    aspect: "aspect-[4/3]",
  },
  {
    src: "/images/plating.png",
    alt: "Sauce poured over a minimalist fine dining dish",
    caption: "The Final Pour",
    wrap: "col-span-12 md:col-span-6 md:mt-16",
    aspect: "aspect-[4/3]",
  },
  {
    src: "/images/dish-mussels.jpeg",
    alt: "Steamed mussels with grilled bread",
    caption: "Mussels, Grilled Bread",
    wrap: "col-span-12 md:col-span-7",
    aspect: "aspect-[4/3]",
  },
  {
    src: "/images/dessert.png",
    alt: "Dark chocolate dessert with gold leaf",
    caption: "Chocolate, Gold Leaf",
    wrap: "col-span-12 md:col-span-5 md:mt-24",
    aspect: "aspect-[3/4]",
  },
  {
    src: "/images/dish-burger.jpeg",
    alt: "Wagyu burger with aged cheddar and pommes frites",
    caption: "Wagyu, Aged Cheddar",
    wrap: "col-span-12 md:col-span-5",
    aspect: "aspect-[3/4]",
  },
  {
    src: "/images/tablescape.png",
    alt: "Private dining tablescape in a Manhattan penthouse",
    caption: "The Private Table",
    wrap: "col-span-12 md:col-span-7 md:mt-24",
    aspect: "aspect-[4/3]",
  },
];

export default function Gallery() {
  return (
    <section
      data-testid="gallery-section"
      className="px-6 sm:px-12 lg:px-20 py-24 md:py-32 lg:py-40 border-b border-white/10"
    >
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1 }}
        className="text-[11px] uppercase tracking-[0.4em] text-[#EAE6DF]/70 mb-6"
      >
        Selected Work
      </motion.p>
      <motion.h2
        data-testid="gallery-heading"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white mb-20 md:mb-28"
      >
        Plates, composed quietly.
      </motion.h2>

      <div className="grid grid-cols-12 gap-5 md:gap-8">
        {IMAGES.map((image, i) => (
          <motion.figure
            key={image.src}
            data-testid={`gallery-item-${i + 1}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className={`${image.wrap} group`}
          >
            <div className={`overflow-hidden ${image.aspect}`}>
              <img
                data-testid={`gallery-image-${i + 1}`}
                src={image.src}
                alt={image.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.03]"
              />
            </div>
            <figcaption className="mt-4 text-[10px] uppercase tracking-[0.3em] text-white/40">
              {image.caption}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
